import { ReviewTranslationDTO } from './ReviewTranslationDTO';

export type ReviewTranslationValue = Record<string, string>;

export const mapReviewTranslation = (dto: ReviewTranslationDTO): ReviewTranslationValue => {
    return dto.translations.reduce<ReviewTranslationValue>((acc, translation) => {
        if (!translation.label) {
            // Skip if the label is not defined because the text will not be usable
            return acc;
        }

        acc[translation.label] = translation.text;
        return acc;
    }, {});
};
